<template>
  <div class="download-container" :class="locale === 'en'?'download-container-en':''">
    <div class="main">
      <div class="content">
        <div class="logo">
          <img
            src="https://img.gotokepler.com/gotokepler/202404171449/01d62d92bec840f19507dabc08d142dc"
            alt=""
          />
        </div>
        <div class="title">{{$t('download.appDownloadTitle')}}</div>
        <div class="desc">{{$t('download.appDownloadDesc')}}</div>
        <div class="download-btn-group">
          <div class="btn scan">
            {{$t('download.qrDownload')}}
            <div class="qrcode">
              <img :src="qrcodeUrl" alt="" />
            </div>
          </div>
          <div class="btn" @click="getAppDownloadUrl">{{$t('download.downloadNow')}}</div>
        </div>
      </div>
      <img
        :src="appPreviewImg"
        alt=""
        class="pad"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { getAppDownloadUrlApi } from "@/api/developer";
import { downloadFile } from "@/utils/downloadFile";
import { useRoute } from 'vue-router';
import { useI18n } from "vue-i18n";
const { locale, t } = useI18n();

const qrcodeUrl = ref("");
const route = useRoute();
const zhUrl = 'https://img.gotokepler.com/image/gotokepler/app-download-zh.png'
const enUrl = 'https://img.gotokepler.com/image/gotokepler/app-download.png'
const appPreviewImg = locale.value === 'en'? enUrl: zhUrl

const imgUrl = [
  {
    path: "https://dev-work-developer.tokit.com",
    qrCodeImg:
      "https://img.gotokepler.com/gotokepler/202404171707/06b109d117a0499996108e456583a994",
  },
  {
    path: "https://test-work-developer.tokit.com",
    qrCodeImg:
      "https://img.gotokepler.com/gotokepler/202404171707/6f325f83f8da4966b3d4ba2cf360702b",
  },
  {
    path: "https://pv-work-developer.tokit.com",
    qrCodeImg:
      "https://img.gotokepler.com/gotokepler/202404171707/65b227fd698446fda4e1a25cfffb849b",
  },
  {
    path: "https://developer.gotokepler.com",
    qrCodeImg:
      "https://img.gotokepler.com/gotokepler/202404171707/3c9d2d5ab3cd4a3cabe9fc77fdede1b7",
  },
];


const linkUrl = location.origin;
const setQrcodeEnvUrl = () => {
  const curEnv =
    imgUrl.find((item) => linkUrl.indexOf(item.path) > -1) || imgUrl[3];
  qrcodeUrl.value = curEnv.qrCodeImg;
};

setQrcodeEnvUrl();

const getAppDownloadUrl = () => {
  getAppDownloadUrlApi()
    .then((res) => {
      if (res.code === 200 && res.result) {
        downloadFile(res.result);
      }
    })
    .catch(() => {});
};


</script>

<style lang="scss" >
.download-container {
  width: 100%;
  position: relative;
  background-image: url(https://img.gotokepler.com/gotokepler/202404171446/99763623ba3f4089b43b6e310cf8b7f5);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  img {
    caret-color: transparent;
  }
  .main {
    width: 100%;
    padding: 207px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    .content {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 152px;
      margin-top: -40px;
      .logo {
        width: 160px;
        height: 160px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .title {
        margin-top: 30px;
        font-size: 36px;
        font-weight: 500;
        line-height: 50.4px;
        text-align: left;
        color: #ffffff;
      }
      .desc {
        margin-top: 15px;
        font-size: 24px;
        line-height: 33.6px;
        text-align: left;
        color: #999999;
      }
      .download-btn-group {
        margin-top: 60px;
        width: 510px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .btn {
          flex-shrink: 0;
          width: 240px;
          height: 64px;
          background: #386aea;
          border-radius: 100px;
          font-size: 20px;
          font-weight: 500;
          color: #ffffff;
          display: flex;
          justify-content: center;
          align-items: center;
          border: none;
          &:active {
            border-color: #386aea;
          }
          &:hover {
            background: rgba(56, 106, 234, 0.8);
            color: rgba(255, 255, 255, 0.8);
          }
        }
        .scan {
          position: relative;
          .qrcode {
            width: 0;
            height: 0;
            position: absolute;
            left: 270px;
            top: -30px;
            background: #ffffff;
            display: flex;
            justify-content: center;
            align-items: center;
            transition: all 0.2s;
            img {
              width: 100%;
              height: 100%;
            }
          }
          &:hover {
            .qrcode {
              width: 240px;
              height: 240px;
            }
          }
        }
      }
    }
    .pad {
      // width: 878px;
      width: 45%;
      max-width: 878px;
      height: auto;
      // margin-right: -30px;
    }
  }
}


// 英文版样式
.download-container-en{
  .desc{
    max-width: 600px;
    word-break: break-word;
  }
}

@media (max-width: 1600px) {
  .download-container {
    .main {
      padding: 167px 0;
      .content {
        .logo {
          width: 140px;
          height: 140px;
        }
        .title {
          font-size: 32px;
        }
        .desc {
          font-size: 20px;
        }
        .download-btn-group {
          width: 470px;
          margin-top: 60px;
          .btn {
            width: 220px;
          }
        }
      }
      .pad {
        // width: %;
      }
    }
  }
}

@media (max-width: 1500px){
  .download-container-en .desc{
    max-width: 86%;
  }
}

@media (max-width: 1280px) {
  .download-container {
    .main {
      padding: 107px 0;
      .content {
        .logo {
          width: 120px;
          height: 120px;
        }
        .title {
          font-size: 30px;
        }
        .desc {
          font-size: 18px;
        }
        .download-btn-group {
          width: 430px;
          margin-top: 40px;
          .btn {
            width: 200px;
          }
        }
      }
      .pad {
        // width: %;
      }
    }
  }
}

/* 纵向iPad（ipad in portrait） */
@media (max-width: 1100px) {
  .download-container {
    width: 100%;
    overflow: hidden;
    .main {
      padding: 50px 0;
      display: block;
      .content {
        margin-right: 0;
        .logo {
          width: 140px;
          height: 140px;
        }
        .title {
          font-size: 32px;
        }
        .desc {
          font-size: 20px;
        }
        .download-btn-group {
          width: 470px;
          margin-top: 60px;
          .btn {
            width: 220px;
          }
        }
      }
      .pad {
        width: 120%;
        margin: 50px auto 0;
        display: block;
      }
    }
  }
}

@media (max-width: 1100px) {
  .download-container {
    width: 100%;
    overflow: hidden;
    .main {
      padding: 50px 0;
      display: block;
      .content {
        margin-right: 0;
        .logo {
          width: 140px;
          height: 140px;
        }
        .title {
          font-size: 32px;
        }
        .desc {
          font-size: 20px;
        }
        .download-btn-group {
          width: 470px;
          margin-top: 60px;
          .btn {
            width: 220px;
          }
        }
      }
      .pad {
        width: 120%;
        margin: 50px auto 0;
        display: block;
      }
    }
  }
}

@media (min-width: 768px) and (max-width: 992px) {
  .download-container {
    width: 100%;
    overflow: hidden;
    .main {
      padding: 80px 0;
      display: block;
      .content {
        margin-right: 0;
        .logo {
          width: 120px;
          height: 120px;
        }
        .title {
          font-size: 28px;
          line-height: 38px;
          margin-top: 28px;
        }
        .desc {
          font-size: 18px;
          line-height: 19.6px;
          margin-top: 10px;
        }
        .download-btn-group {
          width: 375px;
          margin-top: 50px;
          .btn {
            width: 375px;
            font-size: 20px;
            line-height: 23.8px;
          }
          .scan {
            display: none;
          }
        }
      }
      .pad {
        width: 120%;
        margin: 50px auto 0;
        display: block;
        margin-left: -10%;
      }
    }
  }
}

@media (max-width: 767px) {
  .download-container {
    width: 100%;
    overflow: hidden;
    .main {
      padding: 50px 0;
      display: block;
      .content {
        margin-right: 0;
        .logo {
          width: 90px;
          height: 90px;
        }
        .title {
          font-size: 20px;
          line-height: 28px;
          margin-top: 15px;
        }
        .desc {
          font-size: 14px;
          line-height: 19.6px;
          margin-top: 5px;
        }
        .download-btn-group {
          width: 275px;
          margin-top: 30px;
          .btn {
            width: 275px;
            font-size: 17px;
            line-height: 23.8px;
          }
          .scan {
            display: none;
          }
        }
      }
      .pad {
        width: 120%;
        margin: 50px auto 0;
        display: block;
        margin-left: -10%;
      }
    }
  }
}
</style>
